const spacingFn = multiplier => `${multiplier}rem`;

export default {
  spacingFn,
  blockSpacing: spacingFn(1),
};
